import { render, staticRenderFns } from "./contentBannerEdit.vue?vue&type=template&id=5c55e1d4&"
import script from "./contentBannerEdit.vue?vue&type=script&lang=js&"
export * from "./contentBannerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports